<template>
  <div id="table-category-customers" class="table-category-customers-container">
    <vs-table
      ref="tableCustomers"
      noDataText="Sem dados disponíveis"
      :max-items="itemsPerPage"
      search
      :data="customers"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4"
        >
          <div
            class="
              p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg
              cursor-pointer flex items-center justify-between font-medium
            "
          >
            <span class="mr-2">
              {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                    customers.length - currentPage * itemsPerPage > 0
                    ? currentPage * itemsPerPage
                    : customers.length
              }} de {{ queriedItems }}
            </span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Nome</vs-th>
        <vs-th sort-key="phoneNumber">Telefone</vs-th>
        <vs-th
          v-for="(header, key) in filteredTagList"
          :key="`table-header-${key}-${groupId}`"
        >
          {{ header }}  
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)">
            <vs-td>
              <p class="product-email font-medium truncate">{{ tr.name }}</p>
            </vs-td>

            <vs-td
              :colspan="getColspan(tr.sheet_tags)">
              <p class="product-email font-medium truncate">{{ tr.phone_number }}</p>
            </vs-td>

            <vs-td v-if="!filterTagList.includes(key) && index >= startIndex"
              v-for="(value, key) in customerGroupTags(tr.sheet_tags)"
              :key="`table-row-${key}-${groupId}`"
            >
              {{ value }}
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-pagination
      :total="totalPages"
      v-model="currentPage"
      @change="startIndex = (currentPage - 1) * itemsPerPage; fetchCustomers()"
    ></vs-pagination>
  </div>
</template>

<script>
  import customerGroupHttp from "@/http/requests/customerGroup"

  export default {
    name: 'table-category-customers',
    props: {
      tagList: {
        type: Array,
        default: () => []
      },
      groupId: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        customers: [],
        currentPage: 1,
        totalPages: 1,
        itemsPerPage: 4,
        queriedItems: 0,
        isMounted: false,
        tagListView: this.tagList,
        filterTagList: ['id', 'is_blacklisted'],
        startIndex: 0
      }
    },
    computed: {
      filteredTagList() {
        return this.tagList.filter(value => !this.filterTagList.includes(value));
      },
    },
    watch: {
      currentPage: function() {
        this.fetchCustomers()
      },
      itemsPerPage: function() {
        if (this.currentPage === 1) {
          this.fetchCustomers()
        } else {
          this.currentPage = 1
        }
      }
    },
    methods: {
      customerGroupTags(sheetTags) {
        return sheetTags ? JSON.parse(sheetTags) : []
      },
      getColspan(sheetTags) {
        const { length } = this.customerGroupTags(sheetTags)
        return length === 0 ? '100%' : this.filteredTagList.length + 1 - this.startIndex
      },
      fetchCustomers() {
        customerGroupHttp.infosGroupOfCustomer(this.groupId)
        .then(res => {
          this.customers = res.data.data.groupOfCustomerInfos.customers
          this.queriedItems = this.customers.length
          this.totalPages = Math.ceil(this.customers.length / this.itemsPerPage)
        })
        .catch(err => { console.error(err) })
      }
    },
    mounted() {
      this.isMounted = true
      this.fetchCustomers()
    }
  }
</script>

<style lang="scss">
  #table-category-customers {
    width: 100%;

    .vs-con-table {

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;


        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
